import { MODE_TRANSFER } from '@/lib/constants';
import { RouteSequenceApiV4Interface } from '@/types/api-types';

export const getApiOptionReliability = (option: RouteSequenceApiV4Interface): number => {
  const { segments } = option;
  let count = 0;

  const summedArrivalOtp = segments
    .filter((s) => s.routeType !== MODE_TRANSFER)
    .reduce((accum, segment) => {
      if ('arrivalOTP' in segment) {
        const score = segment.arrivalOTP?.quarter?.reliabilityScore || 0;
        if (score) {
          count += 1;
          return accum + score;
        }
      }
      return accum;
    }, 0);

  return summedArrivalOtp ? summedArrivalOtp / count : 0;
};
